import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

export const AllocationCompleted = ({ event }: { event: any }) => {
  const allocationName = event?.data?.allocationName ? (
    <Box as="span" display="inline-block" margin="0 2xs 0 0">
      <strong>{event.data.allocationName}</strong> allocation
    </Box>
  ) : (
    'an allocation'
  );

  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> completed {allocationName}
      </Box>
    </Box>
  );
};
